var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"entrust"}},[_c('section',[_c('entrubanfrom')],1),_c('section',[_c('entruproce')],1),_c('section',{staticClass:"w_fluid"},[_c('entrutable')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }